import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  title: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.title',
    defaultMessage: 'Restrict who can view this form',
    description: 'Title for the form permission configuration modal.'
  },
  description: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.description',
    defaultMessage: 'Control who can view this form once submitted by giving access to specific people. Any changes made to restrictions will only apply to newly submitted forms. <link>Read more about restricting forms</link>',
    description: 'Description for the form permission configuration modal.'
  },
  cancelButton: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.cancel-button',
    defaultMessage: 'Cancel',
    description: 'Cancel button for the form permission configuration modal'
  },
  applyButton: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.apply-button',
    defaultMessage: 'Apply',
    description: 'Apply button for the form permission configuration modal'
  },
  applyButtonLabel: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.apply-button-label',
    defaultMessage: 'Apply restrictions',
    description: 'Label for Apply button for the form permission configuration modal'
  },
  restrictionsLoadFailureDescription: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.restrictions-load-failure-description',
    defaultMessage: 'We couldn’t load restrictions on this page. Refresh the page and try again.',
    description: 'Message shown to the user when loading the restricted principals failed'
  },
  restrictionsApplySuccessTitle: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.restrictions-apply-success-title',
    defaultMessage: 'Restrictions updated',
    description: 'Message shown to the user when they successfully update the restrictions when saving the form permissions'
  },
  restrictionsApplySuccessDescription: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.restrictions-apply-success-description',
    defaultMessage: 'It may take a few moments for these changes to apply.',
    description: 'Description of the flag to show to the user when they successfully apply the restrictions when saving the form permissions.'
  },
  restrictionsApplyFailureTitle: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.restrictions-apply-failure-title',
    defaultMessage: 'We couldn’t update restrictions',
    description: 'Message shown to the user when they failed to update the restrictions when saving the form permissions'
  },
  restrictionsApplyFailureDescription: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.restrictions-apply-failure-description',
    defaultMessage: 'Refresh the page and try again.',
    description: 'Description of the flag to show to the user when they failed to apply the restrictions when saving the form permissions.'
  },
  restrictionsModalCloseIconLabel: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.restrictions-modal-close-icon-label',
    defaultMessage: 'Close modal',
    description: 'Label for the close icon within the form permissions edit modal.'
  },
  formSecurityJiraLinkedFieldWarningDescription: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.form-security-jira-linked-field-warning-description',
    defaultMessage: 'Restrictions set on this form won’t apply to linked Jira fields. Anyone with access to the issue may still be able to see these fields.',
    description: 'The warning description displayed in the form security modal when there exists a jira linked field question and the form is restricted.'
  },
  formSecurityJiraLinkedFieldWarningDescriptionIssueTermRefresh: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.form-security-jira-linked-field-warning-description-issue-term-refresh',
    defaultMessage: 'Restrictions set on this form won’t apply to linked Jira fields. Anyone with access to the work item may still be able to see these fields.',
    description: 'The warning description displayed in the form security modal when there exists a jira linked field question and the form is restricted.'
  },
  formSecurityAttachmentsWarningDescription: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.form-security-attachments-warning-description',
    defaultMessage: 'Restrictions set on this form won’t apply to attachments. Anyone with access to the issue will be able to see attachments.',
    description: 'The warning description displayed in the form security modal when there exists an attachment question and the form is restricted.'
  },
  formSecurityAttachmentsWarningDescriptionIssueTermRefresh: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.form-security-attachments-warning-description-issue-term-refresh',
    defaultMessage: 'Restrictions set on this form won’t apply to attachments. Anyone with access to the work item will be able to see attachments.',
    description: 'The warning description displayed in the form security modal when there exists an attachment question and the form is restricted.'
  },
  formSecurityCombinedWarningDescription: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.form-security-combined-warning-description',
    defaultMessage: 'Restrictions set on this form won’t apply to linked Jira fields or attachments. Anyone with access to the issue will be able to see them.',
    description: 'The warning description displayed in the form security modal when there exists an attachment question and the form is restricted.'
  },
  formSecurityCombinedWarningDescriptionIssueTermRefresh: {
    id: 'proforma-form-security.config-button.config-modal.edit-modal.form-security-combined-warning-description-issue-term-refresh',
    defaultMessage: 'Restrictions set on this form won’t apply to linked Jira fields or attachments. Anyone with access to the work item will be able to see them.',
    description: 'The warning description displayed in the form security modal when there exists an attachment question and the form is restricted.'
  }
});